module.exports = __webpack_public_path__ + "img/EXTERIOR-FRONX-BOOSTERGREEN-2.ddc12a5b.jpg";